module.exports = __webpack_public_path__ + "static/img/2.4598eb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haqcs-as-a-controller-images/top-strip/2.png
// module id = 141
// module chunks = 1 2